import * as React from "react";
const CircleWithChart = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#ED0000", d: "M48 95C22 95 1 74 1 48S22 1 48 1z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M48 95V1c26 0 47 21 47 47S74 95 48 95" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M52 62.9 36.1 47.1 20.3 62.9l-7.1-7L36.1 33 52 48.8l23.7-23.7 7.1 7z" }))));
export default CircleWithChart;
//# sourceMappingURL=CircleWithChart.js.map